module.exports = __webpack_public_path__ + "static/media/taxi~xzSsduXZ.a2a2b019.svg";